/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { withTheme } from 'emotion-theming'
import { useState, useMemo, useCallback, useRef, useEffect } from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import ArrowIcon from 'public/icons/arrow.svg'

import style from './Dropdown.style'

const DropdownStyled = styled.div(props => ({ ...style(props) }))

const Dropdown = ({ label, align, value, options, onChange, isSort }) => {
    const [isOpened, setIsOpened] = useState(false)
    const selectNode = useRef()
    const onClickOutside = e => {
        if (selectNode.current.contains(e.target)) {
            return
        }
        setIsOpened(false)
    }
    useEffect(() => {
        if (isOpened) {
            document.addEventListener('mousedown', onClickOutside)
        } else {
            document.removeEventListener('mousedown', onClickOutside)
        }

        return () => {
            document.removeEventListener('mousedown', onClickOutside)
        }
    }, [isOpened])

    const selectedOption = useMemo(() => {
        let option = (options || []).find(item => item.id === value)
        if (!option) {
            option = (options || [])[0]
        }
        return option || null
    }, [value, options])

    const selectOption = useCallback(option => {
        setTimeout(() => {
            onChange({ target: { value: option.id } })
        })
    }, [])

    return (
        <DropdownStyled align={align} isSort={isSort}>
            <label className="wrap is-mobile">
                {label ? <span className="label-text">{label} </span> : null}
                <select onChange={onChange} value={value}>
                    {options.map(item => (
                        <option key={item.id} value={item.id}>
                            {item.label}
                        </option>
                    ))}
                </select>

                <div className="arrow">
                    <ArrowIcon />
                </div>
            </label>
            <div
                ref={selectNode}
                className={`wrap is-desktop${isOpened ? ' is-opened' : ''}`}
                onClick={() => setIsOpened(!isOpened)}>
                <div className="label">
                    {label ? <>{label} </> : null}
                    {selectedOption ? selectedOption.label : 'Sort'}
                    {options.map(item => (
                        <span key={item.id}>{item.label}</span>
                    ))}
                </div>

                <div className="arrow">
                    <ArrowIcon />
                </div>

                <div className="options">
                    {options.map(item => (
                        <button
                            key={item.id}
                            className={`option${selectedOption.id === item.id ? ' is-selected' : ''}`}
                            type="button"
                            onClick={() => selectOption(item)}>
                            <span>{item.label}</span>
                        </button>
                    ))}
                </div>
            </div>
        </DropdownStyled>
    )
}

Dropdown.propTypes = {
    label: PropTypes.string,
    align: PropTypes.oneOf(['left', 'right']),
    value: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.any,
            label: PropTypes.string
        })
    ),
    onChange: PropTypes.func,
    isSort: PropTypes.bool
}

Dropdown.defaultProps = {
    label: null,
    align: 'left',
    value: undefined,
    options: [],
    onChange: () => {},
    isSort: false
}

export default withTheme(Dropdown)
